import React, { FC, Fragment } from 'react';
import { Link } from '@mui/material';

import { ExternalShare } from 'api';
import theme from 'theme';
import { parseTextWithBackslash, parseTextWithCompany, parseTextWithHashtag } from 'helpers';

const UrlMetadata: FC<ExternalShare> = ({ article_title, user_commentary, share_url }) => {
  function parseText() {
    const parsedText = parseTextWithHashtag(user_commentary);
    const parsedCompany = parseTextWithCompany(parsedText);
    return parseTextWithBackslash(parsedCompany);
  }

  return (
    <Fragment>
      <Link
        sx={{ ...theme.mixins.clampInline(2) }}
        color="textPrimary"
        variant="subtitle2"
        href={share_url}
        target="_blank"
        underline="hover"
      >
        {article_title}
      </Link>
      <Link
        color="textSecondary"
        sx={{ ...theme.mixins.clampInline(5) }}
        target="_blank"
        underline="none"
        href={share_url}
        variant="body1"
      >
        {parseText()}
      </Link>
    </Fragment>
  );
};

export default UrlMetadata;
